// Product Gevel Calculator — Prindal-Hout
// Extracted from inline <script> into an external, deferred asset file.
// Only runs when explicitly initialized via window.PrindalGevelCalc.init(uid) —
// see the lazy-init script at the bottom of snippets/product-gevel-calculator.liquid.
// Mirrors the pattern used for the hek calculator (assets/product-hek-calculator.js).

window.PrindalGevelCalc = (function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function init(uid) {
    var root = document.getElementById(uid);
    if (!root) return;
    if (root.dataset.calcInited === 'true') return;
    root.dataset.calcInited = 'true';

    var dataEl = root.querySelector('[data-gevel-calc-variants]');
    var calcData = { variants: {}, optionNames: [], isProfessional: false, productId: null, labels: {} };
    try { calcData = JSON.parse(dataEl.textContent); } catch (e) { /* houdt defaults aan */ }
    var variants = calcData.variants || {};
    var optionNames = calcData.optionNames || [];
    var labels = calcData.labels || {};

    var directionButtons = root.querySelectorAll('[data-calc-build-direction] [data-direction]');
    var afterDirection = root.querySelector('[data-calc-after-direction]');
    var afterShape = root.querySelector('[data-calc-after-shape]');

    var wallsListEl = root.querySelector('[data-calc-walls-list]');
    var drawingSvg = root.querySelector('[data-calc-drawing-svg]');
    var drawingContent = root.querySelector('[data-calc-drawing-content]');
    var drawingSchematicNote = root.querySelector('[data-calc-drawing-schematic-note]');
    var drawingLegend = root.querySelector('[data-calc-drawing-legend]');
    var addWallBtn = root.querySelector('[data-calc-add-wall]');
    var resetBtn = root.querySelector('[data-calc-reset]');

    var colorBlock = root.querySelector('[data-calc-color-block]');
    var colorPickerEl = root.querySelector('[data-calc-color-picker]');
    var widthBlock = root.querySelector('[data-calc-width-block]');
    var widthPickerEl = root.querySelector('[data-calc-width-picker]');
    var perfectProposalEl = root.querySelector('[data-calc-perfect-proposal]');
    var methodBlock = root.querySelector('[data-calc-method-block]');
    var methodButtons = root.querySelectorAll('[data-calc-build-method] [data-method]');
    var wildScopeBlock = root.querySelector('[data-calc-wild-scope-block]');
    var wildScopeButtons = root.querySelectorAll('[data-calc-wild-scope] [data-scope]');
    var wildLengthBlock = root.querySelector('[data-calc-wild-length-block]');
    var lengthPickerEl = root.querySelector('[data-calc-length-picker]');
    var wildPerWallBlock = root.querySelector('[data-calc-wild-perwall-block]');
    var perWallPickersEl = root.querySelector('[data-calc-perwall-pickers]');
    var wildSummaryEl = root.querySelector('[data-calc-wild-summary]');
    var fullAutoBlock = root.querySelector('[data-calc-full-auto-block]');
    var fullProposalEl = root.querySelector('[data-calc-full-proposal]');

    var elHint = root.querySelector('[data-calc-hint]');
    var elPlankOptions = root.querySelector('[data-calc-plank-options]');
    var elResults = root.querySelector('[data-calc-results]');
    var elArea = root.querySelector('[data-calc-area]');

    var elPriceRows = root.querySelector('[data-calc-price-rows]');
    var elProPriceRows = root.querySelector('[data-calc-pro-price-rows]');
    var elTotalLabel = root.querySelector('[data-calc-total-label]');
    var elTotal = root.querySelector('[data-calc-total]');
    var elProGroup = root.querySelector('[data-calc-pro-group]');
    var elProTotal = root.querySelector('[data-calc-pro-total]');
    var elVoordeel = root.querySelector('[data-calc-voordeel]');
    var elAdd = root.querySelector('[data-calc-add]');
    var elAddError = root.querySelector('[data-calc-add-error]');

    var defaultHintText = elHint.textContent;
    var addLabelBase = labels.addToCart;
    var addedLabel = labels.added;
    var addingLabel = labels.adding;
    var piecesLabel = labels.pieces;
    var totalPlainLabel = labels.totalPlain;
    var totalParticulierLabel = labels.totalParticulier;
    var exclVatLabel = labels.exclVat;
    var mmLabel = ' cm';
    var perfectTitleLabel = labels.perfectTitle;
    var perfectAltNoteLabel = labels.perfectAltNote;
    var fullProposalTitleLabel = labels.fullProposalTitle;
    var fullAltNoteLabel = labels.fullAltNote;
    var planksOfLabel = labels.planksOf;
    var cutForLabel = labels.cutFor;
    var piecesOfLabel = labels.piecesOf;
    var andLabel = labels.and;
    var wallLabelText = labels.wallLabel;
    var removeWallLabel = labels.removeWall;
    var chooseLengthLabel = labels.chooseLength;

    var buildDirection = null;
    var buildMethod = null;
    var adviesRevealed = false;

    var state = {
      colorKey: null,
      widthCm: null,
      wildScope: 'single',
      wildSingleLength: null,
      perfectChoiceIndex: 0,
      fullChoiceIndex: 0
    };
    var walls = [];
    var wallIdCounter = 0;
    var currentUsageQty = {};
    var proUnitCentsByVariant = {};
    var proSyncPending = {};
    var proSyncQueue = [];
    var proSyncInFlight = false;
    function requestProSync(variantId) {
      if (!variantId) return;
      if (proUnitCentsByVariant[variantId] != null) return;
      if (proSyncPending[variantId]) return;
      proSyncPending[variantId] = true;
      proSyncQueue.push(variantId);
      processProSyncQueue();
    }
    function processProSyncQueue() {
      if (proSyncInFlight || !proSyncQueue.length) return;
      proSyncInFlight = true;
      var variantId = proSyncQueue.shift();
      syncProPricing(variantId, function () {
        proSyncInFlight = false;
        processProSyncQueue();
      });
    }

    var isProfessional = !!calcData.isProfessional;

    function formatMoney(cents) {
      var euros = cents / 100;
      return '\u20AC ' + euros.toFixed(2).replace('.', ',');
    }
    function formatMeters(val) {
      var rounded = Math.round(val * 100) / 100;
      return String(rounded).replace('.', ',') + ' m';
    }

    function detectSizeOptionIndex() {
      for (var idx = 0; idx < optionNames.length; idx++) {
        var valueToSize = {}; var consistent = true; var hasMultiple = false;
        for (var id in variants) {
          var v = variants[id];
          var val = v.options[idx];
          var sizeKey = v.plankWidthCm + '|' + v.plankLengthM;
          if (Object.prototype.hasOwnProperty.call(valueToSize, val)) {
            if (valueToSize[val] !== sizeKey) { consistent = false; break; }
          } else { valueToSize[val] = sizeKey; }
        }
        if (!consistent) continue;
        hasMultiple = Object.keys(valueToSize).length > 1;
        if (hasMultiple || optionNames.length === 1) return idx;
      }
      return 0;
    }
    var sizeOptionIndex = detectSizeOptionIndex();

    function colorKeyForVariant(v) {
      var parts = [];
      for (var i = 0; i < v.options.length; i++) { if (i !== sizeOptionIndex) parts.push(v.options[i]); }
      return parts.length ? parts.join(' / ') : null;
    }

    function getAvailableColors() {
      var seen = {}; var out = [];
      for (var id in variants) {
        var ck = colorKeyForVariant(variants[id]);
        if (ck === null) continue;
        if (!seen[ck]) { seen[ck] = true; out.push(ck); }
      }
      return out;
    }
    function getAvailableWidths(colorKey) {
      var seen = {}; var out = [];
      for (var id in variants) {
        var v = variants[id];
        if (!v.plankWidthCm) continue;
        if (colorKey !== null && colorKeyForVariant(v) !== colorKey) continue;
        if (!seen[v.plankWidthCm]) { seen[v.plankWidthCm] = true; out.push(v.plankWidthCm); }
      }
      out.sort(function (a, b) { return a - b; });
      return out;
    }
    function getAvailableLengths(colorKey, widthCm) {
      var seen = {}; var out = [];
      for (var id in variants) {
        var v = variants[id];
        if (!v.plankWidthCm || Math.abs(v.plankWidthCm - widthCm) > 0.01 || !v.plankLengthM) continue;
        if (colorKey !== null && colorKeyForVariant(v) !== colorKey) continue;
        if (!seen[v.plankLengthM]) { seen[v.plankLengthM] = true; out.push(v.plankLengthM); }
      }
      out.sort(function (a, b) { return a - b; });
      return out;
    }
    function variantFor(colorKey, widthCm, lengthM) {
      if (widthCm == null || lengthM == null || isNaN(widthCm) || isNaN(lengthM)) return null;
      for (var id in variants) {
        var v = variants[id];
        if (!v.plankWidthCm || Math.abs(v.plankWidthCm - widthCm) > 0.01) continue;
        if (!v.plankLengthM || Math.abs(v.plankLengthM - lengthM) > 0.005) continue;
        if (colorKey !== null && colorKeyForVariant(v) !== colorKey) continue;
        return id;
      }
      return null;
    }

    function wallLengthM(w) { return parseFloat(w.lengthInput.value) || 0; }
    function wallHeightM(w) { return parseFloat(w.heightInput.value) || 0; }
    function wallArea(w) { return wallLengthM(w) * wallHeightM(w); }
    function totalArea() { return walls.reduce(function (s, w) { return s + wallArea(w); }, 0); }
    function getRowInfoForWall(w) {
      var l = wallLengthM(w), h = wallHeightM(w);
      return buildDirection === 'horizontal' ? { rowLength: l, crossDim: h } : { rowLength: h, crossDim: l };
    }
    function getNumRowsForWall(w, plankWidthCm) {
      var row = getRowInfoForWall(w);
      var widthM = plankWidthCm / 100;
      return Math.ceil((row.crossDim - 0.005) / widthM);
    }
    function allWallsFilled() {
      return walls.length > 0 && walls.every(function (w) { return wallLengthM(w) > 0 && wallHeightM(w) > 0; });
    }

    function findPerfectNoCutOptionsMulti(lengths) {
      var EPS = 0.005; var out = [];
      lengths.forEach(function (L) {
        var allFit = walls.every(function (w) {
          var row = getRowInfoForWall(w).rowLength;
          if (row <= 0) return false;
          var rem = row % L;
          return rem < EPS || (L - rem) < EPS;
        });
        if (allFit) out.push({ length: L });
      });
      return out;
    }

    function ffdBinPack(piecesDescSorted, capacity) {
      var EPS = 0.005;
      var bins = []; var contents = [];
      for (var i = 0; i < piecesDescSorted.length; i++) {
        var p = piecesDescSorted[i];
        if (p.value - capacity > EPS) return null;
        var placed = false;
        for (var b = 0; b < bins.length; b++) {
          if (bins[b] - p.value >= -EPS) { bins[b] -= p.value; contents[b].push(p); placed = true; break; }
        }
        if (!placed) { bins.push(capacity - p.value); contents.push([p]); }
      }
      var waste = bins.reduce(function (s, b) { return s + b; }, 0);
      return { binsUsed: bins.length, waste: waste, binContents: contents };
    }
    function summarizeBinPatterns(binContents) {
      var groups = {}; var order = [];
      binContents.forEach(function (bin) {
        var sorted = bin.slice().sort(function (a, b) { return b.value - a.value; });
        var key = sorted.map(function (p) { return (Math.round(p.value * 1000) / 1000) + '@' + p.wallLabel; }).join('|');
        if (!groups[key]) { groups[key] = { pieces: sorted, count: 0 }; order.push(key); }
        groups[key].count++;
      });
      return order.map(function (key) { return groups[key]; });
    }
    function describePattern(pieces) {
      var seen = {}; var order = [];
      pieces.forEach(function (p) {
        var key = p.value.toFixed(3) + '@' + p.wallLabel;
        if (!seen[key]) { seen[key] = { value: p.value, wallLabel: p.wallLabel, count: 0 }; order.push(key); }
        seen[key].count++;
      });
      return order.map(function (key) {
        var e = seen[key];
        return e.count + ' ' + piecesOfLabel + ' ' + formatMeters(e.value) + ' (' + e.wallLabel + ')';
      }).join(' ' + andLabel + ' ');
    }
    function optimizeFullMethodMulti(lengths) {
      var EPS = 0.005; var candidates = [];
      lengths.forEach(function (mainLen) {
        var grandMainTotal = 0;
        var pieces = [];
        var perWallInfo = [];
        walls.forEach(function (w, wIdx) {
          var row = getRowInfoForWall(w);
          var rows = getNumRowsForWall(w, state.widthCm);
          var mainPerRow = Math.floor((row.rowLength + EPS) / mainLen);
          var rem = row.rowLength - mainPerRow * mainLen; if (rem < EPS) rem = 0;
          grandMainTotal += rows * mainPerRow;
          perWallInfo.push({ id: w.id, mainPerRow: mainPerRow, mainLengthM: mainLen, rem: rem });
          if (rem > 0) {
            var wLabel = wallLabelText + ' ' + (wIdx + 1);
            for (var i = 0; i < rows; i++) pieces.push({ value: rem, wallLabel: wLabel });
          }
        });

        if (!pieces.length) {
          candidates.push({
            mainLengthM: mainLen, mainTotal: grandMainTotal,
            sparePlanks: 0, spareLengthM: null, sparePatterns: [],
            totalPlanks: grandMainTotal, totalWaste: 0, perWallInfo: perWallInfo
          });
          return;
        }

        pieces.sort(function (a, b) { return b.value - a.value; });

        var bestPack = null;
        lengths.forEach(function (spareLen) {
          var pack = ffdBinPack(pieces, spareLen);
          if (!pack) return;
          if (!bestPack || pack.binsUsed < bestPack.binsUsed || (pack.binsUsed === bestPack.binsUsed && pack.waste < bestPack.waste - 0.0001)) {
            bestPack = { spareLengthM: spareLen, result: pack };
          }
        });
        if (!bestPack) return;

        candidates.push({
          mainLengthM: mainLen, mainTotal: grandMainTotal,
          sparePlanks: bestPack.result.binsUsed, spareLengthM: bestPack.spareLengthM,
          sparePatterns: summarizeBinPatterns(bestPack.result.binContents),
          totalPlanks: grandMainTotal + bestPack.result.binsUsed, totalWaste: bestPack.result.waste,
          perWallInfo: perWallInfo
        });
      });
      if (!candidates.length) return null;
      candidates.sort(function (a, b) {
        if (a.totalPlanks !== b.totalPlanks) return a.totalPlanks - b.totalPlanks;
        return a.totalWaste - b.totalWaste;
      });
      return candidates;
    }
    function describeFullResultMulti(r) {
      var lines = [];
      if (r.mainTotal > 0) {
        var mainWallLabels = r.perWallInfo.filter(function (info) { return info.mainPerRow > 0; }).map(function (info) {
          var w = walls.filter(function (ww) { return ww.id === info.id; })[0];
          var idx = walls.indexOf(w);
          return wallLabelText + ' ' + (idx + 1);
        });
        var mainSuffix = mainWallLabels.length ? ' (' + mainWallLabels.join(', ') + ')' : '';
        lines.push('<strong>' + r.mainTotal + '</strong> ' + planksOfLabel + ' ' + formatMeters(r.mainLengthM) + mainSuffix);
      }
      r.sparePatterns.forEach(function (g) {
        var prefix = lines.length ? '+ ' : '';
        lines.push(prefix + '<strong>' + g.count + '</strong> ' + planksOfLabel + ' ' + formatMeters(r.spareLengthM) +
          ' \u2014 ' + cutForLabel + ' ' + describePattern(g.pieces));
      });
      return lines;
    }

    function createWallRow() {
      wallIdCounter++;
      var id = wallIdCounter;

      var tr = document.createElement('tr');
      tr.innerHTML =
        '<td class="gevel-calc__wall-name"></td>' +
        '<td><input type="number" min="0" step="0.01" inputmode="decimal" data-wall-length></td>' +
        '<td><input type="number" min="0" step="0.01" inputmode="decimal" data-wall-height></td>' +
        '<td class="gevel-calc__wall-area"></td>' +
        '<td><button type="button" class="gevel-calc__wall-remove" aria-label="' + removeWallLabel + '">\u00D7</button></td>';
      wallsListEl.appendChild(tr);

      var wall = {
        id: id,
        rowEl: tr,
        titleEl: tr.querySelector('.gevel-calc__wall-name'),
        removeBtn: tr.querySelector('.gevel-calc__wall-remove'),
        lengthInput: tr.querySelector('[data-wall-length]'),
        heightInput: tr.querySelector('[data-wall-height]'),
        areaEl: tr.querySelector('.gevel-calc__wall-area'),
        wildLengthM: null
      };

      wall.lengthInput.addEventListener('input', function () { recalc(); });
      wall.heightInput.addEventListener('input', function () { recalc(); });
      wall.removeBtn.addEventListener('click', function () { removeWall(wall); });

      walls.push(wall);
      renumberWalls();
      return wall;
    }
    function removeWall(wall) {
      if (walls.length <= 1) return;
      var idx = walls.indexOf(wall);
      if (idx === -1) return;
      walls.splice(idx, 1);
      wall.rowEl.parentNode.removeChild(wall.rowEl);
      renumberWalls();
      recalc();
    }
    function renumberWalls() {
      walls.forEach(function (w, i) {
        w.titleEl.textContent = wallLabelText + ' ' + (i + 1);
        w.removeBtn.hidden = walls.length <= 1;
      });
    }
    if (addWallBtn) addWallBtn.addEventListener('click', function () { createWallRow(); recalc(); });

    function renderWallsDrawing(splitInfoByWallId) {
      drawingContent.innerHTML = '';
      var validWalls = walls.filter(function (w) { return wallLengthM(w) > 0 && wallHeightM(w) > 0; });
      if (!validWalls.length) {
        if (drawingSchematicNote) drawingSchematicNote.setAttribute('opacity', '0');
        if (drawingLegend) drawingLegend.hidden = true;
        return;
      }

      var MAX_RATIO = 4;
      var dims = validWalls.map(function (w) {
        var l = wallLengthM(w), h = wallHeightM(w);
        var dl = l, dh = h, schematic = false;
        if (l / h > MAX_RATIO) { dl = h * MAX_RATIO; schematic = true; }
        else if (h / l > MAX_RATIO) { dh = l * MAX_RATIO; schematic = true; }
        return { wall: w, l: l, h: h, dl: dl, dh: dh, schematic: schematic };
      });

      var viewW = 680, viewH = 240, padTop = 42, padSide = 30, padBottom = 46;
      var drawH = viewH - padTop - padBottom;
      var GAP_PX = 26;
      var maxDh = Math.max.apply(null, dims.map(function (d) { return d.dh; }));
      var scale = drawH / maxDh;
      var availWidthPx = viewW - padSide * 2;
      var totalWidthPx = dims.reduce(function (s, d) { return s + d.dl * scale; }, 0) + GAP_PX * (dims.length - 1);
      if (totalWidthPx > availWidthPx) {
        var sumDl = dims.reduce(function (s, d) { return s + d.dl; }, 0);
        scale = (availWidthPx - GAP_PX * (dims.length - 1)) / sumDl;
      }

      var totalDrawnWidth = dims.reduce(function (s, d) { return s + d.dl * scale; }, 0) + GAP_PX * (dims.length - 1);
      var startX = padSide + Math.max(0, (availWidthPx - totalDrawnWidth) / 2);
      var baselineY = padTop + drawH;
      var anySchematic = false;
      var anySplit = false;

      var x = startX;
      dims.forEach(function (d, idx) {
        var w = d.wall;
        if (d.schematic) anySchematic = true;
        var boxW = d.dl * scale, boxH = d.dh * scale;
        var y = baselineY - boxH;

        var g = document.createElementNS(SVG_NS, 'g');

        var rect = document.createElementNS(SVG_NS, 'rect');
        rect.setAttribute('x', x); rect.setAttribute('y', y);
        rect.setAttribute('width', boxW); rect.setAttribute('height', boxH);
        rect.setAttribute('class', 'gevel-calc__preview-shape');
        g.appendChild(rect);

        var FIXED_LINES = boxW < 60 ? 2 : 4;
        for (var i = 1; i <= FIXED_LINES; i++) {
          var line = document.createElementNS(SVG_NS, 'line');
          if (buildDirection === 'vertical') {
            var lx = x + boxW * (i / (FIXED_LINES + 1));
            line.setAttribute('x1', lx); line.setAttribute('y1', y);
            line.setAttribute('x2', lx); line.setAttribute('y2', y + boxH);
          } else {
            var ly = y + boxH * (i / (FIXED_LINES + 1));
            line.setAttribute('x1', x); line.setAttribute('y1', ly);
            line.setAttribute('x2', x + boxW); line.setAttribute('y2', ly);
          }
          line.setAttribute('class', 'gevel-calc__preview-plankline');
          g.appendChild(line);
        }

        var splitInfo = splitInfoByWallId ? splitInfoByWallId[w.id] : null;
        if (splitInfo && (splitInfo.usedLength > 0.001 || splitInfo.remReal > 0.001)) {
          var usedDisp = splitInfo.usedLength * (buildDirection === 'horizontal' ? (d.dl / d.l) : (d.dh / d.h));
          var hasMain = splitInfo.usedLength > 0.001;
          var hasRem = splitInfo.remReal > 0.001;
          if (hasRem) anySplit = true;
          var mainBox, remBox;
          if (buildDirection === 'horizontal') {
            mainBox = { x: x, y: y, w: usedDisp * scale, h: boxH };
            remBox = { x: x + usedDisp * scale, y: y, w: boxW - usedDisp * scale, h: boxH };
          } else {
            mainBox = { x: x, y: y, w: boxW, h: usedDisp * scale };
            remBox = { x: x, y: y + usedDisp * scale, w: boxW, h: boxH - usedDisp * scale };
          }
          if (hasMain) {
            var r1 = document.createElementNS(SVG_NS, 'rect');
            r1.setAttribute('x', mainBox.x); r1.setAttribute('y', mainBox.y);
            r1.setAttribute('width', mainBox.w); r1.setAttribute('height', mainBox.h);
            r1.setAttribute('class', 'gevel-calc__preview-full-box gevel-calc__preview-full-box--main');
            g.appendChild(r1);
          }
          if (hasRem) {
            var r2 = document.createElementNS(SVG_NS, 'rect');
            r2.setAttribute('x', remBox.x); r2.setAttribute('y', remBox.y);
            r2.setAttribute('width', remBox.w); r2.setAttribute('height', remBox.h);
            r2.setAttribute('class', 'gevel-calc__preview-full-box gevel-calc__preview-full-box--rem');
            g.appendChild(r2);
          }
        }

        var nameLbl = document.createElementNS(SVG_NS, 'text');
        nameLbl.setAttribute('x', x + boxW / 2); nameLbl.setAttribute('y', y - 22);
        nameLbl.setAttribute('text-anchor', 'middle'); nameLbl.setAttribute('class', 'gevel-calc__drawing-wall-name');
        nameLbl.textContent = wallLabelText + ' ' + (idx + 1);
        g.appendChild(nameLbl);

        var lenLbl = document.createElementNS(SVG_NS, 'text');
        lenLbl.setAttribute('x', x + boxW / 2); lenLbl.setAttribute('y', y - 8);
        lenLbl.setAttribute('text-anchor', 'middle'); lenLbl.setAttribute('class', 'gevel-calc__preview-label');
        lenLbl.textContent = formatMeters(d.l);
        g.appendChild(lenLbl);

        var hLbl = document.createElementNS(SVG_NS, 'text');
        hLbl.setAttribute('x', x - 6); hLbl.setAttribute('y', y + boxH / 2 + 4);
        hLbl.setAttribute('text-anchor', 'end'); hLbl.setAttribute('class', 'gevel-calc__preview-label');
        hLbl.textContent = formatMeters(d.h);
        g.appendChild(hLbl);

        drawingContent.appendChild(g);
        x += boxW + GAP_PX;
      });

      if (drawingSchematicNote) {
        drawingSchematicNote.setAttribute('opacity', anySchematic ? '1' : '0');
        drawingSchematicNote.setAttribute('y', viewH - 12);
      }
      if (drawingLegend) drawingLegend.hidden = !anySplit;
    }

    directionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buildDirection = btn.getAttribute('data-direction');
        directionButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        afterDirection.hidden = false;
        recalc();
      });
    });

    if (resetBtn) resetBtn.addEventListener('click', function () {
      walls.forEach(function (w) { w.lengthInput.value = ''; w.heightInput.value = ''; w.wildLengthM = null; });
      recalc();
    });

    function renderColorPicker() {
      var colors = getAvailableColors();
      colorBlock.hidden = colors.length === 0;
      colorPickerEl.innerHTML = '';
      colors.forEach(function (ck) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'gevel-calc__variant-btn';
        btn.textContent = ck;
        btn.classList.toggle('is-active', state.colorKey === ck);
        btn.addEventListener('click', function () {
          if (state.colorKey === ck) return;
          var availableWidthsForNewColor = getAvailableWidths(ck);
          state.colorKey = ck;
          if (state.widthCm !== null && availableWidthsForNewColor.indexOf(state.widthCm) === -1) {
            state.widthCm = null;
            state.wildSingleLength = null;
            walls.forEach(function (w) { w.wildLengthM = null; });
          } else if (state.widthCm !== null) {
            var newLengths = getAvailableLengths(ck, state.widthCm);
            if (state.wildSingleLength !== null && newLengths.indexOf(state.wildSingleLength) === -1) state.wildSingleLength = null;
            walls.forEach(function (w) { if (w.wildLengthM !== null && newLengths.indexOf(w.wildLengthM) === -1) w.wildLengthM = null; });
          }
          renderColorPicker(); renderWidthPicker(); recalc();
        });
        colorPickerEl.appendChild(btn);
      });
    }

    function renderWidthPicker() {
      var widths = getAvailableWidths(state.colorKey);
      if (widths.length === 1 && state.widthCm !== widths[0]) {
        state.widthCm = widths[0];
      }
      var onlyOneWidth = widths.length <= 1;
      widthBlock.hidden = onlyOneWidth ? true : (colorBlock.hidden ? false : (state.colorKey === null && getAvailableColors().length > 0));
      widthPickerEl.innerHTML = '';
      widths.forEach(function (wCm) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'gevel-calc__variant-btn';
        btn.textContent = wCm + mmLabel;
        btn.classList.toggle('is-active', state.widthCm === wCm);
        btn.addEventListener('click', function () {
          if (state.widthCm === wCm) return;
          var newLengths = getAvailableLengths(state.colorKey, wCm);
          state.widthCm = wCm;
          if (state.wildSingleLength !== null && newLengths.indexOf(state.wildSingleLength) === -1) state.wildSingleLength = null;
          walls.forEach(function (w) { if (w.wildLengthM !== null && newLengths.indexOf(w.wildLengthM) === -1) w.wildLengthM = null; });
          renderWidthPicker();
          recalc();
        });
        widthPickerEl.appendChild(btn);
      });
    }

    methodButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buildMethod = btn.getAttribute('data-method');
        methodButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        recalc();
      });
    });
    wildScopeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.wildScope = btn.getAttribute('data-scope');
        wildScopeButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        recalc();
      });
    });

    function renderLengthPicker(container, lengths, selectedValue, onSelect) {
      container.innerHTML = '';
      lengths.forEach(function (lenM) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'gevel-calc__variant-btn';
        btn.textContent = formatMeters(lenM);
        btn.classList.toggle('is-active', selectedValue === lenM);
        btn.addEventListener('click', function () { onSelect(lenM); });
        container.appendChild(btn);
      });
    }
    function renderPerWallLengthPickers(lengths) {
      perWallPickersEl.innerHTML = '';
      walls.forEach(function (w) {
        var wrap = document.createElement('div');
        wrap.className = 'gevel-calc__zone-length-row';
        var label = document.createElement('p');
        label.className = 'gevel-calc__subtle-label';
        label.textContent = w.titleEl.textContent + ' \u2014 ' + chooseLengthLabel;
        wrap.appendChild(label);
        var pickerDiv = document.createElement('div');
        pickerDiv.className = 'gevel-calc__variants';
        wrap.appendChild(pickerDiv);
        perWallPickersEl.appendChild(wrap);
        renderLengthPicker(pickerDiv, lengths, w.wildLengthM, function (val) { w.wildLengthM = val; recalc(); });
      });
    }

    function renderProposalBox(container, titleHtml, titleClass, lines, alternatives, currentIndex, onChooseAlt, noteText) {
      container.innerHTML = '';
      var titleEl = document.createElement('p');
      titleEl.className = 'gevel-calc__proposal-title ' + titleClass;
      titleEl.innerHTML = titleHtml;
      container.appendChild(titleEl);
      lines.forEach(function (lineHtml) {
        var p = document.createElement('p');
        p.className = 'gevel-calc__proposal-line';
        p.innerHTML = lineHtml;
        container.appendChild(p);
      });
      if (alternatives && alternatives.length > 1) {
        var note = document.createElement('p');
        note.className = 'gevel-calc__alt-note';
        note.textContent = noteText;
        container.appendChild(note);
        var pickerDiv = document.createElement('div');
        pickerDiv.className = 'gevel-calc__variants';
        alternatives.forEach(function (alt, idx) {
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'gevel-calc__variant-btn';
          btn.textContent = alt.label;
          btn.classList.toggle('is-active', idx === currentIndex);
          btn.addEventListener('click', function () { onChooseAlt(idx); });
          pickerDiv.appendChild(btn);
        });
        container.appendChild(pickerDiv);
      }
    }

    function recalc() {
      walls.forEach(function (w) {
        w.areaEl.textContent = (wallLengthM(w) > 0 && wallHeightM(w) > 0) ? wallArea(w).toFixed(2).replace('.', ',') + ' m\u00B2' : '';
      });
      renderWallsDrawing(null);

      if (!buildDirection) return;

      var wallsReady = allWallsFilled();
      afterShape.hidden = !wallsReady;
      if (!wallsReady) {
        elHint.textContent = defaultHintText; elHint.hidden = false;
        elPlankOptions.hidden = true; elResults.hidden = true;
        if (!adviesRevealed) root.classList.add('gevel-advies-pending');
        elAdd.disabled = true;
        return;
      }

      renderColorPicker(); renderWidthPicker();
      if (state.widthCm === null) {
        elHint.hidden = false; elPlankOptions.hidden = true; elResults.hidden = true;
        perfectProposalEl.hidden = true; methodBlock.hidden = true;
        wildScopeBlock.hidden = true; wildLengthBlock.hidden = true; wildPerWallBlock.hidden = true; fullAutoBlock.hidden = true;
        if (!adviesRevealed) root.classList.add('gevel-advies-pending');
        elAdd.disabled = true;
        return;
      }

      var lengths = getAvailableLengths(state.colorKey, state.widthCm);
      var usageQty = {};
      function addUsage(id, qty) { if (!id || !qty) return; usageQty[id] = (usageQty[id] || 0) + qty; }

      var perfectOptions = findPerfectNoCutOptionsMulti(lengths);

      if (perfectOptions.length > 0) {
        perfectProposalEl.hidden = false;
        methodBlock.hidden = true; wildScopeBlock.hidden = true; wildLengthBlock.hidden = true; wildPerWallBlock.hidden = true; fullAutoBlock.hidden = true;
        wildSummaryEl.hidden = true; wildSummaryEl.innerHTML = '';

        if (state.perfectChoiceIndex >= perfectOptions.length) state.perfectChoiceIndex = 0;
        var chosenPerfect = perfectOptions[state.perfectChoiceIndex];
        var grandTotal = 0;
        var perfectSplitMap = {};
        walls.forEach(function (w) {
          var row = getRowInfoForWall(w);
          var rows = getNumRowsForWall(w, state.widthCm);
          var perRow = Math.round(row.rowLength / chosenPerfect.length);
          grandTotal += rows * perRow;
          perfectSplitMap[w.id] = { usedLength: row.rowLength, remReal: 0 };
        });
        renderWallsDrawing(perfectSplitMap);
        var lines = ['<strong>' + grandTotal + '</strong> ' + planksOfLabel + ' ' + formatMeters(chosenPerfect.length)];
        var altObjs = perfectOptions.map(function (o) { return { label: formatMeters(o.length) }; });
        renderProposalBox(perfectProposalEl, perfectTitleLabel, '', lines, altObjs, state.perfectChoiceIndex, function (idx) { state.perfectChoiceIndex = idx; recalc(); }, perfectAltNoteLabel);

        addUsage(variantFor(state.colorKey, state.widthCm, chosenPerfect.length), grandTotal);
      } else {
        perfectProposalEl.hidden = true; methodBlock.hidden = false;
        wildScopeBlock.hidden = true; wildLengthBlock.hidden = true; wildPerWallBlock.hidden = true; fullAutoBlock.hidden = true;
        wildSummaryEl.hidden = true; wildSummaryEl.innerHTML = '';

        if (buildMethod === 'wild') {
          var scopeIrrelevant = walls.length <= 1 || lengths.length <= 1;
          var effectiveWildScope = scopeIrrelevant ? 'single' : state.wildScope;
          wildScopeBlock.hidden = scopeIrrelevant;
          wildScopeButtons.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-scope') === state.wildScope); });

          if (effectiveWildScope === 'perwall') {
            wildPerWallBlock.hidden = false;
            renderPerWallLengthPickers(lengths);
            var perWallLines = [];
            walls.forEach(function (w) {
              if (w.wildLengthM == null) return;
              var vid = variantFor(state.colorKey, state.widthCm, w.wildLengthM);
              var vv = vid ? variants[vid] : null;
              if (!vv) return;
              var qtyW = Math.ceil(wallArea(w) / vv.m2);
              addUsage(vid, qtyW);
              perWallLines.push('<strong>' + qtyW + '</strong> ' + planksOfLabel + ' ' + formatMeters(w.wildLengthM) + ' \u2014 ' + w.titleEl.textContent);
            });
            if (perWallLines.length) {
              wildSummaryEl.hidden = false; wildSummaryEl.innerHTML = '';
              perWallLines.forEach(function (html) { var p = document.createElement('p'); p.className = 'gevel-calc__proposal-line'; p.innerHTML = html; wildSummaryEl.appendChild(p); });
            } else { wildSummaryEl.hidden = true; wildSummaryEl.innerHTML = ''; }
          } else {
            wildLengthBlock.hidden = false;
            var onlyOneLength = lengths.length <= 1;
            if (onlyOneLength) state.wildSingleLength = lengths[0] || null;
            lengthPickerEl.hidden = onlyOneLength;
            var subtleLbl = wildLengthBlock.querySelector('.gevel-calc__subtle-label');
            if (subtleLbl) subtleLbl.hidden = onlyOneLength;
            renderLengthPicker(lengthPickerEl, lengths, state.wildSingleLength, function (val) { state.wildSingleLength = val; recalc(); });

            if (state.wildSingleLength != null) {
              var vid2 = variantFor(state.colorKey, state.widthCm, state.wildSingleLength);
              var vv2 = vid2 ? variants[vid2] : null;
              if (vv2) {
                var totalPlanksSingle = Math.ceil(totalArea() / vv2.m2);
                addUsage(vid2, totalPlanksSingle);
                wildSummaryEl.hidden = false; wildSummaryEl.innerHTML = '';
                var p2 = document.createElement('p'); p2.className = 'gevel-calc__proposal-line';
                p2.innerHTML = '<strong>' + totalPlanksSingle + '</strong> ' + planksOfLabel + ' ' + formatMeters(state.wildSingleLength);
                wildSummaryEl.appendChild(p2);
              } else { wildSummaryEl.hidden = true; wildSummaryEl.innerHTML = ''; }
            } else { wildSummaryEl.hidden = true; wildSummaryEl.innerHTML = ''; }
          }
        } else if (buildMethod === 'full') {
          fullAutoBlock.hidden = false;
          var results = optimizeFullMethodMulti(lengths);
          if (state.fullChoiceIndex >= (results ? results.length : 0)) state.fullChoiceIndex = 0;
          var chosenFull = results ? results[state.fullChoiceIndex] : null;
          if (chosenFull) {
            var fLines = describeFullResultMulti(chosenFull);
            var fAlts = results.map(function (r) { return { label: formatMeters(r.mainLengthM) }; });
            renderProposalBox(fullProposalEl, fullProposalTitleLabel, 'gevel-calc__proposal-title--full', fLines, fAlts, state.fullChoiceIndex, function (idx) { state.fullChoiceIndex = idx; recalc(); }, fullAltNoteLabel);

            addUsage(variantFor(state.colorKey, state.widthCm, chosenFull.mainLengthM), chosenFull.mainTotal);
            if (chosenFull.sparePlanks > 0) {
              addUsage(variantFor(state.colorKey, state.widthCm, chosenFull.spareLengthM), chosenFull.sparePlanks);
            }
            var fullSplitMap = {};
            chosenFull.perWallInfo.forEach(function (info) {
              fullSplitMap[info.id] = { usedLength: info.mainPerRow * info.mainLengthM, remReal: info.rem };
            });
            renderWallsDrawing(fullSplitMap);
          } else {
            fullProposalEl.innerHTML = '';
          }
        }
      }

      var usageVariantIds = Object.keys(usageQty);
      currentUsageQty = usageQty;

      if (!usageVariantIds.length) {
        elHint.hidden = false; elPlankOptions.hidden = true; elResults.hidden = true;
        if (!adviesRevealed) root.classList.add('gevel-advies-pending');
        elAdd.disabled = true;
        return;
      }

      elHint.hidden = true; elPlankOptions.hidden = false;
      elArea.textContent = totalArea().toFixed(2).replace('.', ',') + ' m\u00B2';

      var totalCents = 0, totalPlanks = 0;
      elPriceRows.innerHTML = '';
      usageVariantIds.forEach(function (vid3) {
        var qty = usageQty[vid3];
        var vv = variants[vid3];
        if (!vv) return;
        totalCents += qty * vv.price;
        totalPlanks += qty;
        var row2 = document.createElement('div');
        row2.className = 'gevel-calc__row';
        row2.innerHTML = '<span>' + qty + ' ' + piecesLabel + ' \u2014 ' + vv.title + '</span>' +
          '<strong>' + formatMoney(vv.price) + ' (' + formatMoney(vv.price / vv.m2) + '/m\u00B2)</strong>';
        elPriceRows.appendChild(row2);
      });

      elTotalLabel.textContent = isProfessional ? totalParticulierLabel : totalPlainLabel;
      elTotal.textContent = formatMoney(totalCents);

      var proReady = usageVariantIds.length > 0 && usageVariantIds.every(function (vid4) { return proUnitCentsByVariant[vid4] != null; });
      if (proReady) {
        var proTotalCents = 0;
        elProPriceRows.innerHTML = '';
        usageVariantIds.forEach(function (vid5) {
          var qty = usageQty[vid5];
          var vv2b = variants[vid5];
          if (!vv2b) return;
          var proCents = proUnitCentsByVariant[vid5];
          proTotalCents += qty * proCents;
          var row3 = document.createElement('div');
          row3.className = 'gevel-calc__row';
          row3.innerHTML = '<span>' + qty + ' ' + piecesLabel + ' \u2014 ' + vv2b.title + '</span>' +
            '<strong>' + formatMoney(proCents) + ' (' + formatMoney(proCents / vv2b.m2) + '/m\u00B2)</strong>';
          elProPriceRows.appendChild(row3);
        });
        elProTotal.textContent = formatMoney(proTotalCents) + ' ' + exclVatLabel;
        elVoordeel.textContent = formatMoney(totalCents - proTotalCents);
        elProGroup.hidden = false;
      } else {
        elProGroup.hidden = true;
      }

      elResults.hidden = false;
      root.classList.remove('gevel-advies-pending');
      adviesRevealed = true;
      var allAvailable = usageVariantIds.every(function (vid6) { var vv3 = variants[vid6]; return vv3 && vv3.available; });
      elAdd.disabled = !allAvailable;
      elAdd.textContent = allAvailable ? addLabelBase + ' (' + totalPlanks + ' ' + piecesLabel + ')' : addLabelBase;

      if (isProfessional) {
        usageVariantIds.forEach(function (vid7) { requestProSync(vid7); });
      }
    }

    function refreshCartCountBadges() {
      fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
        var selectors = '.cart-count, [data-cart-count], #CartCount, .js-cart-count, .cart-link__bubble, .cart-count-bubble';
        document.querySelectorAll(selectors).forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
    }

    elAdd.addEventListener('click', function () {
      var variantIds = Object.keys(currentUsageQty);
      if (!variantIds.length) return;
      var items = variantIds.map(function (id) { return { id: parseInt(id, 10), quantity: currentUsageQty[id] }; });

      elAdd.disabled = true; elAdd.textContent = addingLabel; elAddError.hidden = true;

      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Error'); }); return res.json(); })
        .then(function () {
          elAdd.textContent = addedLabel;
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          refreshCartCountBadges();
          setTimeout(function () { elAdd.disabled = false; recalc(); }, 2000);
        })
        .catch(function (err) { elAdd.disabled = false; recalc(); elAddError.textContent = err.message; elAddError.hidden = false; });
    });

    function syncProPricing(variantId, done) {
      var mainProductEl = document.querySelector('[data-section-type="product"]');
      var sectionId = mainProductEl ? mainProductEl.getAttribute('data-section-id') : null;
      var productUrl = root.getAttribute('data-product-url');
      if (!sectionId || !productUrl) { done(); return; }
      var url = productUrl + '?variant=' + variantId + '&section_id=' + sectionId;
      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        done();
      }
      fetch(url).then(function (res) { return res.text(); }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var priceId = 'product-price-' + calcData.productId;
        var fresh = doc.getElementById(priceId); var live = document.getElementById(priceId);
        if (!fresh || !live) { finish(); return; }
        live.innerHTML = fresh.innerHTML;
        live.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          if (oldScript.src) newScript.src = oldScript.src; else newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
        var attempts = 0, maxAttempts = 20;
        var poll = setInterval(function () {
          attempts++;
          var proCell = live.querySelector('.prindal-m2-pro-cell[data-gevel-pro-unit-placeholder]');
          if (proCell && proCell.getAttribute('data-filled-for') === String(variantId)) {
            var text = proCell.textContent || '';
            var num = parseFloat(text.replace(/[^\d,.-]/g, '').replace(',', '.'));
            if (num) { proUnitCentsByVariant[variantId] = Math.round(num * 100); recalc(); }
            clearInterval(poll);
            finish();
          } else if (attempts >= maxAttempts) { clearInterval(poll); finish(); }
        }, 300);
      }).catch(function () { finish(); });
    }

    createWallRow();
    recalc();
  }

  return { init: init };
})();